module.exports = __webpack_public_path__ + "static/media/relentless-dedication2.b3128f41.svg";